export const NOT_FOUND = 'NotFound';

export enum ProviderPlanStatus {
  PROVIDER = 'PROVIDER',
  PLAN = 'PLAN',
}

export enum ProviderListSort {
  LATEST = 'LATEST',
  PRICE_LOW = 'PRICE_LOW',
  PRICE_HIGH = 'PRICE_HIGH',
  RATED_HIGH = 'RATED_HIGH',
}

export enum PlanListSort {
  LATEST = 'LATEST',
  PRICE_LOW = 'PRICE_LOW',
  PRICE_HIGH = 'PRICE_HIGH',
}

export enum ServiceType {
  DOMESTIC = 'DOMESTIC',
  OVERSEAS_HOTEL = 'OVERSEAS_HOTEL',
}

export enum TagsValue {
  GIFT_VOUCHER = 'ギフト券付き',
  TODAY_LIMIT = '当日限定プラン',
}

export enum GradeHotelType {
  HIGH_CLASS_HOTEL = 1,
  TOP_CLASS_HOTEL = 2,
}

export enum GradeMemberRank {
  DIAMOND_RANK_MEMBER = 'Diamond',
  PLATINUM_RANK_MEMBER = 'Platinum',
}

export enum MemberBenefit {
  DIAMOND_RANK_MEMBER_BENEFIT = 'ダイヤモンド会員優待あり',
  PLATINUM_RANK_MEMBER_BENEFIT = 'プラチナ会員優待あり',
  MEMBER_BENEFIT = '優待',
}
